import React from 'react';
import {useField} from 'formik';
import CLInput, {CLInputProps} from '../../CLInput/CLInput';
import CLFormValidatedInput from '../CLFormValidatedInput/CLFormValidatedInput';
import {FormInputProps} from '../CLForm.types';

function CLFormInput({
  onChange,
  onBlur,
  name,
  label,
  required,
  labelClassName,
  formInputClassName = '',
  errorType,
  validationErrorClassName = '',
  ...props
}: FormInputProps<CLInputProps>) {
  const [fieldInput, fieldMeta, fieldHelpers] = useField(name);

  return (
    <CLFormValidatedInput
      validationError={fieldMeta.touched ? fieldMeta.error : ''}
      label={label}
      required={required}
      labelClassName={labelClassName}
      className={formInputClassName}
      errorType={errorType}
      validationErrorClassName={validationErrorClassName}
    >
      <CLInput
        dimension="full"
        {...props}
        name={name}
        value={fieldInput.value ?? ''}
        onChange={(value) => {
          fieldHelpers.setValue(value);
          onChange && onChange(value);
        }}
        onBlur={(e) => {
          setTimeout(() => {
            fieldInput.onBlur(e);
          }, 200);
          onBlur && onBlur(e);
        }}
      />
    </CLFormValidatedInput>
  );
}

export default CLFormInput;
